import { MenuItem, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import BkDropdownMenu from '../../../components/dropdown-menu/BkDropdownMenu';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { Button } from 'src/components/new/Button';
import { PaymentMethodsStatus } from 'src/utils/enums/payment-method-status.enum';
import { isLegalMailingEnabled } from 'src/utils/featureFlags';

type MenuItem = {
  label: string;
  onClick: () => void;
};

interface UploadMailingProps {
  sx?: any;
  isOpen?: boolean;
}

export const UploadMailings: React.FC<UploadMailingProps> = ({ sx = {}, isOpen = true }) => {
  const currentUser = useSelector((state: RootState) => state.user.currentUser);
  const hasFailedPayment = useSelector((state: RootState) => state.user.hasFailedPayment);
  const paymentMethodsStatus = useSelector(
    (state: RootState) => state.company.paymentMethodsStatus,
  );

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const navigate = useNavigate();

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (type?: 'notice-bk' | 'legal' | 'direct') => {
    navigate(`/create-notice/${type}/add-case-information`);
    handleClose();
  };

  const menuItems: MenuItem[] = [
    {
      label: 'Bankruptcy Notice',
      onClick: () => handleOptionClick('notice-bk'),
    },
    ...(isLegalMailingEnabled()
      ? [{ label: 'Legal Mailing', onClick: () => handleOptionClick('legal') }]
      : []),
    { label: 'Direct Mailing', onClick: () => handleOptionClick('direct') },
  ];

  return (
    <Tooltip
      disableHoverListener={isOpen}
      disableFocusListener={isOpen}
      disableTouchListener={isOpen}
      placement="top"
      title={'Upload Mailing'}
    >
      <span style={{ display: 'contents' }}>
        <Button
          disabled={hasFailedPayment || paymentMethodsStatus === PaymentMethodsStatus.MISSING}
          sx={sx}
          type="primary"
          startIcon={<AddIcon />}
          onClick={handleButtonClick}
        >
          {isOpen ? 'Upload Mailing' : ''}
        </Button>
        <BkDropdownMenu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose} menuItems={menuItems} />
      </span>
    </Tooltip>
  );
};
